<template>
  <div class="gameview" id="gameview"></div>
</template>

<script>
import { Emitter, upgradeConfig } from '@pixi/particle-emitter'
import { Application, Container, Loader, Sprite } from 'pixi.js'

export default {
  props: {
    gameoverCB: null
  },
  data() {
    return {
      gameApp: new Application({
        width: window.innerWidth > 750 ? 750 : window.innerWidth,
        height: window.innerHeight,
        transparent: true
      }),
      container: new Container(),
      particleContainer: new Container(),
      step: 0,
      count: 0.01
    }
  },
  async beforeMount() {},
  async mounted() {
    // console.log(this.gameApp)
    document.querySelector('#gameview').appendChild(this.gameApp.view)
    this.container.sortableChildren = true
    this.container.interactive = true
    this.gameApp.stage.addChild(this.container)
    this.gameApp.stage.addChild(this.particleContainer)
    Loader.shared
      .add('lineShort', require('@/assets/games/motion/LineSHORT.png'))
      .add('pointNormal', require('@/assets/games/motion/PointNORMAL.png'))
      .add('background', require('@/assets/games/motion/background.jpg'))
      .add('cong', require('@/assets/games/motion/CONG.png'))
      .load((loader, resources) => {
        let emitter = null
        this.showSlash(
          resources,
          () => {
            if (this.step === 2) {
              this.step++
              emitter.destroy()
              this.showCongratulations(resources, () => {
                this.gameApp.destroy()
                Loader.shared.reset()
                // Loader.shared.destroy()
                document.querySelector('#gameview').remove()
                if (this.gameoverCB) this.gameoverCB()
              })
            }
          },
          () => {
            if (this.step === 1) {
              this.step++
              this.showParticle2(resources)
            }
          },
          (x) => {
            if (this.step === 0) {
              this.step++
              emitter = this.showParticle(resources)
            }
            emitter.spawnPos.set(
              emitter.spawnPos.x,
              this.gameApp.renderer.height * 0.65 -
                (x + 0.1) * (this.gameApp.renderer.height * 0.25)
            )
          }
        )
      })
    // console.log(Assets)
    // const texture = await Texture.from(require('@/assets/games/bunny.png'))
  },
  methods: {
    showSlash(res, finishCB, centerCB, startCB) {
      const texture = res.background.texture
      const bunny = new Sprite(texture)
      bunny.x = this.gameApp.renderer.width / 2
      bunny.y = this.gameApp.renderer.height * 0.8
      // Rotate around the center
      bunny.anchor.x = 0.5
      bunny.anchor.y = 0.8
      bunny.width = (bunny.width / bunny.height) * window.innerHeight
      bunny.height = window.innerHeight
      bunny.alpha = 0
      bunny.interactive = true
      // bunny.scale.set(0.2, 0.2)
      bunny.on('click', async () => {
        await this.showEnter(bunny)
      })
      bunny.on('pointerdown', async () => {
        await this.showEnter(bunny)
      })
      // Add the bunny to the scene we are building
      bunny.zIndex = 1
      this.container.addChild(bunny)
      // Listen for frame updates
      this.gameApp.ticker.add(() => {
        // each frame we spin the bunny around a bit
        bunny.alpha += 0.1

        if (bunny.scale.x <= 0.7 && bunny.alpha >= 1) {
          if (bunny.scale.x >= 0.2 && startCB) startCB(bunny.scale.x)
          this.count = 0.1
          bunny.scale.set(
            bunny.scale.x + Math.pow(this.count, 2),
            bunny.scale.y + Math.pow(this.count, 2)
          )
        } else if (bunny.scale.x <= 0.8) {
          this.count = 0.03
          bunny.scale.set(
            bunny.scale.x + Math.pow(this.count, 2),
            bunny.scale.y + Math.pow(this.count, 2)
          )
          if (centerCB) centerCB()
          if (finishCB) finishCB()
        }
        // console.log(bunny.scale.x)
      })
    },
    showCongratulations(res, cb) {
      const texture = res.cong.texture
      const bunny = new Sprite(texture)
      var coungratulationsCount = 0
      bunny.x = this.gameApp.renderer.width / 2
      bunny.y = this.gameApp.renderer.height * 0.4
      // Rotate around the center
      bunny.anchor.x = 0.5
      bunny.anchor.y = 0.5
      bunny.width = (bunny.width / bunny.height) * window.innerHeight
      bunny.height = window.innerHeight
      bunny.alpha = 1
      bunny.scale.set(0.3, 0.3)
      bunny.interactive = true
      bunny.on('click', async () => {
        await this.showEnter(bunny)
      })
      bunny.on('pointerdown', async () => {
        await this.showEnter(bunny)
      })
      // Add the bunny to the scene we are building
      bunny.zIndex = 2
      this.container.addChild(bunny)
      // Listen for frame updates
      this.gameApp.ticker.add(() => {
        // each frame we spin the bunny around a bit
        coungratulationsCount += 0.015
        if (coungratulationsCount >= 1 && cb) cb()
      })
    },
    showParticle(res) {
      var emitter = new Emitter(
        // The PIXI.Container to put the emitter in
        // if using blend modes, it's important to put this
        // on top of a bitmap, and not use the root stage Container
        this.particleContainer,
        upgradeConfig(
          {
            alpha: {
              start: 0.65,
              end: 0.1
            },
            scale: {
              start: 0.01,
              end: 0.2,
              minimumScaleMultiplier: 5
            },
            color: {
              start: '#ffffff',
              end: '#ffffff'
            },
            speed: {
              start: 500,
              end: 300,
              minimumSpeedMultiplier: 3
            },
            acceleration: {
              x: 0,
              y: 0
            },
            maxSpeed: 0,
            startRotation: {
              min: 0,
              max: 360
            },
            noRotation: false,
            rotationSpeed: {
              min: 0,
              max: 0
            },
            lifetime: {
              min: 1,
              max: 0.5
            },
            blendMode: 'normal',
            frequency: 0.01,
            emitterLifetime: 100,
            maxParticles: 10000,
            pos: {
              x: this.gameApp.renderer.width / 2,
              y: this.gameApp.renderer.height * 0.65
            },
            addAtBack: false,
            spawnType: 'burst',
            particlesPerWave: 4,
            particleSpacing: 0,
            angleStart: 0
          },
          [res.lineShort.texture]
        )
      )
      // Calculate the current time
      var elapsed = Date.now()

      // Update function every frame
      var update = function () {
        // Update the next frame
        requestAnimationFrame(update)

        var now = Date.now()
        // The emitter requires the elapsed
        // number of seconds since the last update
        emitter.update((now - elapsed) * 0.001)
        elapsed = now
      }
      // Start emitting
      emitter.emit = true
      emitter.zIndex = 0

      // Start the update
      update()
      return emitter
    },
    showParticle2(res) {
      var emitter = new Emitter(
        // The PIXI.Container to put the emitter in
        // if using blend modes, it's important to put this
        // on top of a bitmap, and not use the root stage Container
        this.particleContainer,
        upgradeConfig(
          {
            alpha: {
              start: 0.65,
              end: 0.1
            },
            scale: {
              start: 0.1,
              end: 0.5,
              minimumScaleMultiplier: 2
            },
            color: {
              start: '#ffffff',
              end: '#ffffff'
            },
            speed: {
              start: 500,
              end: 1,
              minimumSpeedMultiplier: 0.2
            },
            acceleration: {
              x: 0,
              y: 0
            },
            maxSpeed: 0,
            startRotation: {
              min: 0,
              max: 360
            },
            noRotation: false,
            rotationSpeed: {
              min: 0,
              max: 0
            },
            lifetime: {
              min: 10,
              max: 0.5
            },
            blendMode: 'normal',
            frequency: 0.001,
            emitterLifetime: 0.4,
            maxParticles: 40000,
            pos: {
              x: this.gameApp.renderer.width / 2,
              y: this.gameApp.renderer.height * 0.4
            },
            addAtBack: false,
            spawnType: 'burst',
            particlesPerWave: 3,
            particleSpacing: 0,
            angleStart: 8
          },
          [res.pointNormal.texture]
        )
      )
      // Calculate the current time
      var elapsed = Date.now()

      // Update function every frame
      var update = function () {
        // Update the next frame
        requestAnimationFrame(update)

        var now = Date.now()

        // The emitter requires the elapsed
        // number of seconds since the last update
        emitter.update((now - elapsed) * 0.001)
        elapsed = now
      }

      // Start emitting
      emitter.emit = true
      emitter.zIndex = 0

      // Start the update
      update()
      return emitter
    }
  }
}
</script>
<style lang="scss">
.gameview {
  position: fixed;
  z-index: 1;
  max-width: 750px;
}
</style>



// WEBPACK FOOTER //
// src/components/GameView.vue